import constants from 'config/constants';

let src;
if (constants.ENV === 'production') {
  src = 'https://dashboard.zipsure.ca/ziptenant/newQuote';
} else {
  src = 'https://staging-nuera.nude.dev/renters/';
}

export default {
  src,
};
